<template>
	<div class="container page" style="background-color: #1f1c1f;">
		<van-nav-bar :title="$t('my.task_record')" class="nav-bar">
			<template #left>
				<img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;" />
			</template>
		</van-nav-bar>

		<div class="main">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-empty v-if="!list || list.length === 0" :description="$t('withdraw.empty_data')" />
				<div v-else class="item_list" v-for="(v,key) in list" :key="key">
					<div class="lottery_info">
						<van-image class="cover" :src="v.ico">
							<template v-slot:loading>
								<van-loading type="spinner" />
							</template>
						</van-image>
						<span class="period-number">{{ v.expect || v.name || '-' }}</span>
					</div>
					
					<div class="recent">
						<div class="kuaisan-ball left">
							<div>
								<span>{{$t("reservation.result")}}</span>
								<span class="ressquareBox">{{ v.size || '-' }}</span>
								<span class="ressquareBox">{{ v.double || '-' }}</span>
							</div>
						</div>
					</div>
					
					<div class="recent" v-if="v.data && v.data.length > 0">
						<div class="kuaisan-ball left">
							<div>
								<span>{{$t("q36")}}</span>
								<span class="ressquareBox" v-for="(citem, idx) in v.data" :key="idx">
									{{ calcSize(citem.type) }}
								</span>
							</div>
						</div>
					</div>
					
					<div class="topInfo">
						<span v-if="v.status === 1" style="color: #07c160">{{ v.status_text || '-' }}</span>
						<span v-else>{{ v.status_text || '-' }}</span>
						<span>{{$t("reservation.money")}}：{{ v.money || '0' }}</span>
					</div>
					
					<div class="time">
						<span>{{$t("reservation.order_time")}}：{{ v.create_time || '-' }}</span>
					</div>
					<div class="time">
						<span>{{$t("reservation.settle_time")}}：{{ v.update_time || '-' }}</span>
					</div>
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isLoading: false,
				list: [],
				sum: '',
				double: '',
				size: ""
			};
		},
		methods: {
			back() {
				return window.history.back();
			},
			onRefresh() {
				setTimeout(() => {
					this.$toast(this.$t("reservation.refresh"));
					this.isLoading = false;
					this.getUserGameList();
				}, 500);
			},
			calcSize(el) {
				if (!el) return '';
				
				console.log(el);
				const lanng = localStorage.getItem("lang");
				
				if (el == "one") {
					return lanng == 'zh' ? "煙花" : lanng == 'en' ? "Cruise" : lanng == 'ja' ? "ヨット" : "불꽃놀이";
				}
				if (el == "two") {
					return lanng == 'zh' ? "氣球" : lanng == 'en' ? "Rose" : lanng == 'ja' ? "バラ" : "풍선";
				}
				if (el == "big") {
					return lanng == 'zh' ? '玫瑰' : lanng == 'en' ? 'Rocket' : lanng == 'ja' ? 'ロケット' : '장미';
				}
				if (el == "small") {
					return lanng == 'zh' ? '百合' : lanng == 'en' ? 'Heart' : lanng == 'ja' ? "ハート" : '백합';
				}
				return '';
			},
			getUserGameList() {
				this.$http({
					method: 'get',
					url: 'user_get_game_list'
				}).then(res => {
					if (res.code === 200) {
						const lanng = localStorage.getItem("lang");
						let clist = res.data || [];
						
						let list = [];
						clist.forEach(item => {
							let size = "",
								double = "";
							
							// 安全检查：确保 opencode 存在且是数组
							if (item.opencode && Array.isArray(item.opencode) && item.opencode.length >= 3) {
								const sum = Number(item.opencode[0]) + Number(item.opencode[1]) + Number(item.opencode[2]);
								
								if (sum >= 11 && sum <= 18) {
									size = lanng == 'zh' ? '玫瑰' : lanng == 'en' ? 'Rocket' : lanng == 'ja' ? 'ロケット' : '장미';
								} else if (sum >= 3 && sum <= 10) {
									size = lanng == 'zh' ? '百合' : lanng == 'en' ? 'Heart' : lanng == 'ja' ? "ハート" : '백합';
								}
								
								if (sum % 2 === 0) {
									double = lanng == 'zh' ? "氣球" : lanng == 'en' ? "Rose" : lanng == 'ja' ? "バラ" : "풍선";
								} else {
									double = lanng == 'zh' ? "煙花" : lanng == 'en' ? "Cruise" : lanng == 'ja' ? "ヨット" : "불꽃놀이";
								}
							} else {
								console.warn('Invalid opencode for item:', item.id, item.opencode);
							}
							
							// 确保 data 字段是数组
							if (!item.data) {
								item.data = [];
							}
							
							list.push({
								...item,
								size,
								double
							});
						});
						
						this.list = list;
						console.log(list, "--132");
					} else if (res.code === 401) {
						this.$toast(res.msg);
						this.$router.push({
							path: '/Login'
						});
					} else {
						this.$toast(res.msg || '数据加载失败');
					}
				}).catch(error => {
					console.error('API请求失败:', error);
					this.$toast(this.$t('network_error') || '网络错误，请稍后重试');
				});
			}
		},
		created() {
			if (!localStorage.getItem('token')) {
				this.$router.push({
					path: '/Login'
				});
			} else {
				this.getUserGameList();
			}
		},
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
		color: #000000;
		font-size: 35px;
	}

	::v-deep .van-loading__text {
		color: #000000;
		font-size: 35px;
	}

	.container .main {
		position: relative;
		overflow: auto;
		background-color: #1f1c1f;
		height: 100%;
		padding: 0 10px;
	}

	.item_list {
		padding: 15px 15px;
		margin: 30px 10px;
		background: linear-gradient(120deg, #212121, #313131);
		border-radius: 10px;
		line-height: 60px;
		color: #f3c7a2;
		border: 1px solid #766350;
	}

	.item_list .topInfo span {
		flex: 1;
		font-size: 32px;
		font-weight: 700;
		color: #f3c7a2;
	}

	.item_list .time span {
		flex: 1;
		font-size: 25px;
		font-weight: 500;
		color: #f3c7a2;
	}

	.item_list .topInfo span:last-child {}

	.item_list .desc span {
		font-size: 25px;
		font-weight: 700;
		color: #9b9b9b;
	}

	.item_list .cover {
		width: 60px;
		height: 60px;
		-o-object-fit: cover;
		object-fit: cover;
	}

	.item_list .period-number {
		margin-left: 50px;
		margin-right: 10px;
		height: 50px;
		line-height: 60px;
		font-size: 35px;
		font-weight: 700;
		color: #f3c7a2;
	}

	.item_list .lottery_info {
		display: flex;
	}

	.recent {
		display: flex;
		align-items: center;
		height: 100px;
	}

	.kuaisan-ball .left {
		justify-content: flex-start;
	}

	.kuaisan-ball {
		flex: 1;
		display: flex;
		align-items: center;
	}

	.kuaisan-ball .res-img {
		width: 70px;
		height: 70px;
		margin-right: 30px;
	}

	.kuaisan-ball .res-des {
		font-weight: 700;
		text-align: center;
		color: #f3c7a2;
	}

	.kuaisan-ball .res-des.middle {
		width: 15%;
		font-size: 35px;
	}

	.ressquareBox {
		background: linear-gradient(#fde3ca, #e7b486);
		color: #333;
		height: 7vw;
		line-height: 7vw;
		text-align: center;
		font-size: 3vw;
		font-weight: 700;
		border-radius: 16px;
		margin-left: 20px;
		padding: 13px 40px;
		min-width: 13vw;
		white-space: nowrap;
	}
</style>